// Keep list links, sharing URLs and canonical URLs on the API's published alias.
const SITE_ORIGIN = 'https://www.navlindaily.com'

function articlePath(article) {
  const id = String(article.id).replace(/^0+(?=\d)/, '')
  const alias = typeof article.alias === 'string' ? article.alias.trim() : ''
  return `/article/${encodeURIComponent(id)}${alias ? '/' + encodeURIComponent(alias) : ''}`
}

function articleUrl(article) {
  return SITE_ORIGIN + articlePath(article)
}

// CommonJS lets the Node build and Vue bundle share the exact URL policy.
module.exports = { SITE_ORIGIN, articlePath, articleUrl }
